// if (process.env.NODE_ENV != 'development') {
//   __webpack_public_path__ = window.__PUBLIC_PATH__ || '/wp-content/themes/mo/';
// }
import css from './sass/style.scss';

require('./js/stickybits')
require('./js/fonts')
require('./js/init')
require('./js/nav')
require('./js/no-widows')
require('./js/polyfills')
require('./js/scrollpos')
require('./js/smoothscroll')

document.querySelectorAll('[class^="gs-"], [class*=" gs-"]').length > 0 ? import('./js/anims') : false;

if (document.querySelectorAll('.js-glightbox').length > 0) {
  import(
    './js/glightbox'
  );
}

if (document.querySelectorAll('.js-reviews').length > 0) {
  import(
    './js/carousels'
  );
}

if (document.querySelector('.js-testimonials')) {
  import(
    './js/testimonials'
  );
}

if (document.getElementById('timer')) {
  import(
    './js/countdown'
  );
}

if (document.getElementById('videoContent')) {
  import(
    './js/video-content'
  );
}

if (document.getElementById('chapters-nav')) {
  import(
    './js/chapters-nav'
  );
}
